import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20 bg-[#FAFAFA]">
      <div className="w-full max-w-md">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#71717A] mb-4">
          Admin / Restricted
        </p>
        <h1 className="font-display font-black text-5xl md:text-6xl leading-[0.9] mb-10">
          Sign in.
        </h1>
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="border border-black bg-white p-8 space-y-5"
        >
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-2">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              data-testid="admin-email-input"
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-black/15 px-4 py-3 font-mono text-sm focus:outline-none focus:border-black focus:ring-2 focus:ring-black/10 rounded-none"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-2">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              data-testid="admin-password-input"
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-black/15 px-4 py-3 font-mono text-sm focus:outline-none focus:border-black focus:ring-2 focus:ring-black/10 rounded-none"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-ink w-full bg-black text-white px-6 py-4 font-mono text-xs uppercase tracking-[0.25em] disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in →"}
          </button>
        </form>
      </div>
    </div>
  );
}
